import { CardHistoricoProps } from "../../Base/types";
import CardHistoricoBase from "../../Base/CardHistoricoBase";
import { UserCog, LucideIcon } from "lucide-react";
import ExpandedContent from "./ExpandedContent";

const detectaProfissionalAlterado = (acao: string): boolean => {
    const acaoLower = acao.toLowerCase().trim();
    return (acaoLower.includes('alterou profissional') || 
           acaoLower.includes('profissional alterado')) &&
           !acaoLower.includes('atribuiu profissional');
};

const getIconProfissionalAlterado = (acao: string): { Icon: LucideIcon; color: string } => {
    return { Icon: UserCog, color: 'var(--cf59e0b)' };
};

export default function CardProfissionalAlterado({ 
    item, 
    onNavigateToFile, 
    isExpanded, 
    onToggleExpand 
}: CardHistoricoProps) {
    return (
        <CardHistoricoBase
            item={item}
            icon={getIconProfissionalAlterado(item.acao)}
            temExpansaoDisponivel={true}
            isExpanded={isExpanded}
            onToggleExpand={onToggleExpand}
            expandedContent={
                <ExpandedContent item={item} onNavigateToFile={onNavigateToFile} />
            }
        />
    );
}

export const profissionalAlteradoConfig = {
    tipo: 'profissional_alterado',
    detectaTipo: detectaProfissionalAlterado,
    getIcon: getIconProfissionalAlterado,
    temExpansao: () => true,
    Component: CardProfissionalAlterado
};

